import Image from "next/image"

// `brand` is the shipped logo file, not a tinted derivative of it: the chrome shows
// the wordmark exactly as nelo.mx does.
const WORDMARK_SRC = {
  white: "/images/wordmark-white.svg",
  blue: "/images/wordmark-blue.svg",
  brand: "/images/nelo_logo_web.svg",
}

const WORDMARK_RATIO = 113.846 / 50

const RATIO: Record<keyof typeof WORDMARK_SRC, number> = { white: WORDMARK_RATIO, blue: WORDMARK_RATIO, brand: 68 / 30 }

export const Wordmark = ({ tone = "white", height = 22, className }: { tone?: keyof typeof WORDMARK_SRC; height?: number; className?: string }) => (
  <Image src={WORDMARK_SRC[tone]} alt="Nelo" width={Math.round(height * RATIO[tone])} height={height} className={className} />
)
